module.exports = __webpack_public_path__ + "static/media/level.6e1903ec.png";